<template>
    <div class="field has-addons mb-0">
        <div class="search-input-wrap control is-expanded has-icons-right mr-4">
            <input class="input" type="text" :placeholder="placeholder"
                   :value="value" @input="onInput" @keyup.enter="onEnter" autocomplete="off">
            <span v-if="value" class="icon is-small is-right">
                <a class="delete" @click="onClear"></a>
            </span>
            <div class="search-progress-track">
                <div v-if="showProgress" :key="progressKey" class="search-progress-bar"
                 :style="{ '--search-duration': `${animationDuration}ms` }"></div>
            </div>
        </div>
        <div class="control mr-4">
            <a class="button is-primary" @click="onSearch" :disabled="disabled">
                Search
            </a>
        </div>
        <slot />
    </div>
</template>

<script>
    const PROGRESS_DELAY = 300;
    const SEARCH_DELAY = 2000;
    const ANIMATION_DURATION = SEARCH_DELAY - PROGRESS_DELAY;

    export default {
        name: 'SearchBar',
        props: {
            value: { type: String, default: '' },
            placeholder: { type: String, default: 'Search...' },
            disabled: { type: Boolean, default: false },
        },
        data() {
            return {
                debounceTimer: null,
                progressTimer: null,
                showProgress: false,
                progressKey: 0,
                animationDuration: ANIMATION_DURATION,
                lastSearched: this.value,
            };
        },
        methods: {
            onInput(e) {
                const val = e.target.value;
                this.$emit('input', val);
                this.resetTimers();

                if (val.length >= 3 && val !== this.lastSearched) {
                    this.progressTimer = setTimeout(() => {
                        this.progressKey++;
                        this.showProgress = true;
                    }, PROGRESS_DELAY);

                    this.debounceTimer = setTimeout(() => {
                        this.showProgress = false;
                        this.lastSearched = val;
                        this.$emit('search');
                    }, SEARCH_DELAY);
                }
            },
            onEnter() {
                this.cancelProgress();
                this.lastSearched = this.value;
                this.$emit('search');
            },
            onSearch() {
                this.cancelProgress();
                this.lastSearched = this.value;
                this.$emit('search');
            },
            onClear() {
                this.cancelProgress();
                this.lastSearched = null;
                this.$emit('input', '');
                this.$emit('clear');
            },
            resetTimers() {
                clearTimeout(this.debounceTimer);
                clearTimeout(this.progressTimer);
                this.showProgress = false;
            },
            cancelProgress() {
                this.resetTimers();
            },
        },
        beforeDestroy() {
            this.resetTimers();
        },
    };
</script>

<style>
    .search-input-wrap {
        position: relative;
    }

    .search-progress-track {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 3px;
        border-radius: 0 0 4px 4px;
        overflow: hidden;
    }

    .search-progress-bar {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 100%;
        z-index: 5;
        background: hsl(213, 48.6%, 55%);
        transform-origin: left center;
        animation: search-countdown var(--search-duration, 2200ms) linear forwards;
    }

    @keyframes search-countdown {
        from { transform: scaleX(1); }
        to   { transform: scaleX(0); }
    }
</style>
